module.exports = __webpack_public_path__ + "static/media/linkchimp-100x103.1ab330cb.png";